export const CREATE_ROLE = 'CREATE_ROLE';
export const EDIT_ROLE = 'EDIT_ROLE';
export const SHOW_ROLE = 'SHOW_ROLE';
export const ROLE_SUCCESS = 'ROLE_SUCCESS';
export const ROLE_ERROR = 'ROLE_ERROR';

